<template>
  <!-- <v-navigation-drawer
    v-model="primaryDrawer.model"
    :mini-variant="toogleBar"
    app
    overflow
    class="am-sidebar"
    :class="toogleBar ? 'w-70' : 'w-225'"
  > -->
  <v-navigation-drawer
    :mini-variant="isMiniVarient"
    :permanent="isPermanent"
    app
    overflow
    class="am-sidebar"
    width="235"
  >
  <v-list
    nav
    avatar
    class="am-list-items"
  >
    <!-- <v-list-item two-line :class="miniVariant && 'px-0'"> -->
    <img :src="getImgUrl('amara_logo_white')" height="44" width="220" :class="miniVariant && 'px-0'" class="mb-2">
    <!-- </v-list-item> -->
    <v-list-item-group>
      <v-list-item @click="changeTab(`/?tab=overview`, 1)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="dashboard-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-home" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Dashboard</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-home</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="changeTab(`/employees`, 2)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="employees-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-user-friends" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Employees</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-user-friends</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Employees</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item  @click="changeTab(`/analytics`, 3)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="analytics-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-chart-bar" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Analytics</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-chart-bar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Analytics</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item  @click="changeTab(`/drivers`, 4)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="drivers-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-life-ring" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Driver Engagement</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-life-ring</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Driver Engagement</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item  @click="changeTab(`/comments`, 5)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="comments-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-comment" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Comments</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-comment</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Comments</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item  @click="changeTab(`/question-engagement`, 6)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="question-engagement-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-list-ul" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Questions Score</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-list-ul</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Questions Score</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item  @click="changeTab(`/ad-hoc`, 7)" link class="adhoc-list">
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="adhoc-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-bezier-curve" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Ad-Hoc</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-bezier-curve</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Ad-Hoc</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item style="position: fixed;bottom: 60px;" @click="changeTab(`/settings`, 8)" link>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="settings-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="ml-n1"
              >
                <i class="las la-cog" style="color:#9f88f1"></i>
              </span>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Settings</span>
              </div>
            </div>
          </v-menu>
          <v-icon v-else color="#9f88f1">las la-cog</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item style="position: fixed;bottom: 15px;" disabled>
        <v-list-item-avatar size="32">
          <v-menu open-on-hover offset-x right v-if="toogleBar" content-class="profile-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <!-- <span>
                <i class="las la-cog" style="color:#9f88f1"></i>
              </span> -->
              <v-avatar size="30" class="profile-avatar ml-n1" v-bind="attrs" v-on="on">
                <img v-if="user.user_profile.profilePicture" :src="user.user_profile.profilePicture" :alt="user.user_profile.profilePicture">
                <v-img v-else src="../../assets/male-avatar.png"></v-img>
              </v-avatar>
            </template>
            <div class="tooltip-box">
              <div class="am-tooltip">
                <span class="tooltip-text">Your profile</span>
              </div>
            </div>
          </v-menu>
          <v-avatar size="30" class="profile-avatar" v-else>
            <img v-if="user.user_profile.profilePicture" :src="user.user_profile.profilePicture" :alt="user.user_profile.profilePicture">
            <v-img v-else src="../../assets/male-avatar.png"></v-img>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{user.first_name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
  <v-list
    nav
    avatar
    class="am-list-items w-100"
  >
    <v-list-item-group class="w-100" style="position: fixed;bottom: 15px;">
    </v-list-item-group>
  </v-list>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450"
  >
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="black">las la-times-circle</v-icon>
         Insufficient Permissions
      </v-card-title>
      <v-card-text>You may not have the appropriate permissions to access this tab.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'sidebar',
  props: {
    toogleBar: {
      required: true,
      type: Boolean
    },
    isMiniVarient: {
      required: true,
      type: Boolean
    },
    size: {
      required: true,
      type: Number
    }
  },

  watch: {
    sidebarOpen () {
      // console.log('toogleBar, sidebarOpen watch', this.sidebarOpen);
      this.primaryDrawer.model = this.sidebarOpen;
    },
    size () {
      // console.log('this.size', this.size);
      if (this.size < 1250) {
        this.isPermanent = true;
      } else {
        this.isPermanent = false;
      }
    },
    $route: {
      immediate: true,
      handler () {
        if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name !== 'Settings' && this.$route.name !== 'NewAdhoc' && this.$route.name !== 'EditAdhoc' && this.$route.name !== 'ViewAdhoc') {
          this.$router.push('/ad-hoc').catch(() => {});
        }
        if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name !== 'Settings' && this.$route.name === 'ViewAdhoc') {
          this.$router.push(`${this.$route.fullPath}`).catch(() => {});
        }
        if (!this.checkPermission(['company_culture_dashboard']) && !this.checkPermission(['create_adhoc']) && !this.checkPermission(['manage_adhoc']) && this.$route.name !== 'Settings') {
          this.$router.push('/404').catch(() => {});
        }
        if (this.checkPermission(['company_culture_dashboard']) && (!this.checkPermission(['create_adhoc']) && !this.checkPermission(['manage_adhoc'])) && this.$route.name === 'Adhoc') {
          this.$router.push('/').catch(() => {});
        }
      }
    }
  },

  data () {
    return {
      showSubMenu: false,
      isPermanent: false,
      dialog: false,
      primaryDrawer: {
        model: true,
        type: 'default (no property)',
        clipped: false,
        floating: false,
        mini: false
      },
      miniVariant: false,
      items1: [
        {
          action: 'fas fa-chart-bar',
          title: 'Analytics',
          active: false,
          items: [
            { title: 'Employee lifecycle', to: '/analytics/life-cycle' },
            { title: 'Employee participation', to: '/analytics/response-rate' },
            { title: 'Chat participation', to: '/analytics/participation-rate' },
            { title: 'Gender-wise engagement analysis', to: '/analytics/diversity-report' }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState({
      sidebarOpen: state => state.sidebarOpen,
      snackbar: state => state.snackbar,
      user: state => state.user,
      isDashboardPermission: state => state.isDashboardPermission,
      selectedRowData: state => state.selectedRowData,
      candidateUploadingStatus: state => state.candidateUploadingStatus,
      userWidth: state => state.userWidth,
      companySettings: state => state.csettings
    })
  },
  updated () {
    // console.log('userWidth', this.userWidth);
    // console.log(this.$route.path);
  },
  beforeMount () {
    if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name !== 'Settings' && this.$route.name !== 'NewAdhoc' && this.$route.name !== 'EditAdhoc' && this.$route.name !== 'ViewAdhoc') {
      this.$router.push('/ad-hoc').catch(() => {});
    }
    if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name === 'ViewAdhoc') {
      this.$router.push(`${this.$route.fullPath}`).catch(() => {});
    }
    if (!this.checkPermission(['company_culture_dashboard']) && !this.checkPermission(['create_adhoc']) && !this.checkPermission(['manage_adhoc']) && this.$route.name !== 'Settings') {
      this.$router.push('/404').catch(() => {});
    }
    // console.log(this.checkPermission(['company_culture_dashboard']));
    // console.log(this.$route.path);
    // if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc']))) {
    //   this.$router.push('/ad-hoc').catch(() => {});
    // }
    // if (!this.checkPermission(['company_culture_dashboard']) && !this.checkPermission(['create_adhoc']) && !this.checkPermission(['manage_adhoc'])) {
    //   this.$router.push('/404').catch(() => {});
    // }
    // if (!this.tabPermission.adhoc && this.$route.path === '/ad-hoc') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.dashboard && this.$route.path === '/') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.employee && this.$route.path === '/employees') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.driver && this.$route.path === '/drivers') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.question && this.$route.path === '/question-engagement') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.analytics && this.$route.path === '/analytics') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.settings && this.$route.path === '/settings') {
    //   this.$router.push('/404');
    // }
    // if (!this.tabPermission.comments && this.$route.path === '/comments') {
    //   this.$router.push('/404');
    // }
  },
  mounted () {
    if (!this.companySettings) {
      this.getAlertWords();
    }
    if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name !== 'Settings' && this.$route.name !== 'NewAdhoc' && this.$route.name !== 'EditAdhoc' && this.$route.name !== 'ViewAdhoc') {
      this.$router.push('/ad-hoc').catch(() => {});
    }
    if (!this.checkPermission(['company_culture_dashboard']) && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc'])) && this.$route.name === 'ViewAdhoc') {
      this.$router.push(`${this.$route.fullPath}`).catch(() => {});
    }
    if (!this.checkPermission(['company_culture_dashboard']) && !this.checkPermission(['create_adhoc']) && !this.checkPermission(['manage_adhoc']) && this.$route.name !== 'Settings') {
      this.$router.push('/404').catch(() => {});
    }
  },
  methods: {
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    getAlertWords () {
      axios.get(`${process.env.VUE_APP_API_URL}company/settings/${this.user.company}`).then((res) => {
        if (res.status === 200) {
          this.$store.dispatch('companySettings', res.data);
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/logo', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    closeSubMenu () {
      setTimeout(() => {
        this.showSubMenu = false;
      }, 3000);
    },
    changeTab (redirect, val) {
      this.$store.dispatch('updateEmployeeFilters', null);
      if ((this.checkPermission(['company_culture_dashboard']) && val === 1) || (this.checkPermission(['company_culture_dashboard']) && val === 2) || (this.checkPermission(['company_culture_dashboard']) && val === 5) || (this.checkPermission(['company_culture_dashboard']) && val === 4) || (this.checkPermission(['company_culture_dashboard']) && val === 3) || val === 8 || (this.checkPermission(['company_culture_dashboard']) && val === 6)) {
        this.$router.push(`${redirect}`).catch(() => {});
      } else if (val === 7 && (this.checkPermission(['create_adhoc']) || this.checkPermission(['manage_adhoc']))) {
        this.$router.push(`${redirect}`).catch(() => {});
      } else {
        this.dialog = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.am-sidebar {
  // background: linear-gradient(90deg,#61245e,#42276f 90%);
  // background: linear-gradient(120deg,#42276f, #61245e 90%);
  // background-color: #050550;
  background: rgb(52,43,126);
  // background: #584475;
  background: #050550;
  background-image: -webkit-gradient(linear, right top, left top, from(rgba(51,148,225,.18)), to(transparent));
  // background: linear-gradient(150deg, rgba(52,43,126,1) 0%, rgba(84,72,189,1) 70%, rgba(143,72,189,1) 100%, rgba(197,36,55,1) 100%);
  &.w-225 {
    width: 225px;
  }
  &.w-70 {
    width: 70px !important;
  }
  .am-list-items {
    .v-list-item__title {
      color: #9f88f1 !important;
    }
    .v-list-item--active {
      i {
        color: #ffffff !important;
        caret-color: #ffffff !important;
      }
      .v-list-item__title {
        color: #ffffff !important;
      }
    }
    .v-list-item {
      &:hover {
        i {
          color: #bba2ff !important;
          caret-color: #bba2ff !important;
        }
        .v-list-item__title {
          transition: 0.5s ease;
          color: #ffffff !important;
        }
      }
    }
    .adhoc-list {
      border-top: 2px solid #9f88f1;
      border-radius: 0;
    }
  }
  .nav-menu {
    padding: 0;
    margin: 0;
    list-style: none;
    li {
      position: relative;
      a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        outline: 0;
        // padding: .8125rem 2rem;
        // padding: .8125rem 1rem;
        padding: 0.8125rem 1rem 0.8125rem 0.5rem;
        font-size: .875rem;
        color: #bdafd1;
        font-weight: 400;
        text-decoration: none;
        position: relative;
        transition: all .3s ease-out;
        &::hover {
            color: #fff;
            text-decoration: none;
            background-color: rgba(0,0,0,.1);
        }
      }
    }
    ul {
      padding-left: 0;
      list-style: none;
      display: none;
    }
    li > ul {
      // background-color: rgba(0,0,0,.1);
      padding-top: 10px;
      padding-bottom: 10px;
      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 1;
        // left: 1.5625rem;
        left: 1.2rem;
        // top: 44px;
        top: 50px;
        bottom: 0;
        border-left: 1px solid #9f88f1;
      }
    }
    li a>[class*=la-] {
      // margin-right: .25rem;
      margin-right: 1.5rem;
      font-size: 1.125rem;
      width: 1.75rem;
      color: #9f88f1;
      text-align: left;
    }
    ul > li {
      a {
        color: #9f88f1;
        // padding: .8125rem 2rem .8125rem 4.3rem;
        padding: .8125rem 2rem .8125rem 3.7rem;
        &:after {
          content: "";
          display: block;
          position: absolute;
          width: .4rem;
          height: .4rem;
          background-color: #9f88f1;
          // left: 1.4rem;
          left: 1rem;
          top: calc(50% - .3rem);
          border: 1px solid #333;
          border-radius: 50%;
          z-index: 1;
        }
      }
    }
    .nav-link-text {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      line-height: normal;
      // font-size: .875rem;
      font-size: 16px;
      // color: #fff;
    }
    b.collapse-sign {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      color: #967bbd;
      margin-left: 4.5rem;
    }
    li:hover > ul {
      // display: block!important;
      z-index: 1;
      // animation: animateFadeInLeft .5s;
      // -webkit-animation: animateFadeInLeft .5s;
      // -webkit-box-shadow: 0 0 40px 0 rgba(82,63,105,.15);
      box-shadow: 0 0 40px 0 rgba(82,63,105,.15);
    }
  }
  .v-list-item--active {
    .v-list-item__content {
      color: #fff !important;
    }
  }
}
</style>

<style lang="scss">
.am-list-group {
  position: relative;
  .v-list-group__header {
    padding-left: 18px !important;
    .v-list-item__icon {
      i {
        color: #9f88f1;
      }
      &::first-child {
        margin-right: 20px !important;
      }
    }
    .v-list-group__header__prepend-icon {
      margin-right: 20px !important;
    }
    &.v-list-item--active {
      .v-list-item__icon {
        i {
          color: #ffffff;
        }
      }
    }
    .v-list-group__items > .v-list-item {
      padding-left: 54px !important;
    }
  }
  .v-list-group__items {
    .v-list-item {
      padding-left: 54px !important;
    }
    // background: red;
    &::before {
      content: "";
      display: block;
      position: absolute;
      z-index: 1;
      // left: 1.5625rem;
      left: 1.2rem;
      // top: 44px;
      top: 50px;
      bottom: 0;
      border-left: 1px solid #9f88f1;
    }
    a {
      &::after {
        min-height: unset;
        content: "";
        display: block;
        position: absolute;
        width: .4rem;
        height: .4rem;
        background-color: #9f88f1;
        left: 1rem;
        top: calc(50% - .3rem);
        border: 1px solid #333;
        border-radius: 50%;
        z-index: 1;
      }
    }
  }
}
.am-tooltip {
  width: 200px;
  background: #050550;
  color: #ffffff;
  text-align: left;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  top: 50%;
  left: calc(100% + 11px);
  transform: translate(8%, 0%);
  font-weight: 500;
  .tooltip-text {
    &::after {
      content: "";
      position: absolute;
      top: 30%;
      left: -16px;
      margin-left: 0;
      border-width: 8px;
      transform: rotate(90deg);
      border-style: solid;
      border-color: #050550 transparent transparent transparent;
    }
  }
}
.tooltip-box {
  position: relative
}
.dashboard-tooltip {
  box-shadow: none !important;
  top: 70px !important;
  left: 46px !important;
}
.employees-tooltip {
  box-shadow: none !important;
  top: 126px !important;
  left: 46px !important;
}
.adhoc-tooltip {
  box-shadow: none !important;
  top: 405px !important;
  left: 46px !important;
}
.profile-tooltip {
  box-shadow: none !important;
  // top: 214px !important;
  top: calc(100vh - 60px) !important;
  left: 46px !important;
}
.settings-tooltip {
  box-shadow: none !important;
  top: calc(100vh - 115px) !important;
  // top: 214px !important;
  left: 46px !important;
}
.drivers-tooltip {
  box-shadow: none !important;
  top: 236px !important;
  // top: 214px !important;
  left: 46px !important;
}
.comments-tooltip {
  box-shadow: none !important;
  top: 296px !important;
  // top: 214px !important;
  left: 46px !important;
}
.question-engagement-tooltip {
  box-shadow: none !important;
  top: 350px !important;
  // top: 214px !important;
  left: 46px !important;
}
.analytics-tooltip {
  .tooltip {
    // border-radius: 10px 10px 0 0;
  }
  box-shadow: none !important;
  top: 182px !important;
  left: 46px !important;
  .sub-menu {
    background: #050550;
    width: 184px;
    margin-left: 16px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    ul {
      list-style: none;
      padding-bottom: 8px;
      padding-left: 0px !important;
      li {
        padding: 4px 0;
        padding-left: 24px !important;
        color: #9f88f1;
        &:hover {
          background: rgba(0,0,0,0.1);
          color: #ffffff;
          transition: 0.25s ease all;
        }
      }
    }
  }
}
.am-sidebar {
  .v-navigation-drawer__border {
    display: none !important;
    border: 0 !important
  }
  .v-list-item--active {
    &::before {
      background-color: transparent;
      // border-bottom: 2px solid #fff;
      opacity: 1;
      border-radius: 0;
    }
  }
}
</style>
